
  <div class="inicio">
    <form #insertForm="ngForm" [formGroup]="formActualizar" (ngSubmit)="actualizarEquipo()">
      <div class="form-group">
      </div>
        <!--TITULO -->
        <p class="pInfo"  >DETALLE DE EQUIPO <mat-icon color="primary" matTooltip="Click para más información" (click)="botonInformacion()" >info</mat-icon></p>
        <br>
        <div class="grid-container2">
          <p class="titulo"> {{ this.formActualizar.value.nombreInventario }}</p>
          <div class="grid-container2">
            <button *ngIf="this.banderaForm==false && this.isEditable()"  color="primary" mat-mini-fab type="button"  class="btn btn-primary mx-auto d-block"  (click)="habilitarEdicion()" > <mat-icon>mode_edit</mat-icon> </button>
            <button *ngIf="this.banderaForm && this.isEditable()"  color="warn" mat-mini-fab type="button"  class="btn btn-primary mx-auto d-block"  (click)="habilitarEdicion()" >  <mat-icon>block</mat-icon> </button>
            <div  class="wrapper"   *ngIf="this.banderaForm==false" >
              <!--Botón regresar-->
              <button mat-raised-button color="accent" (click)="goBack()" > <mat-icon>navigate_before</mat-icon> REGRESAR</button>
            </div>
          </div>
        </div>
        <br>
        <div class="requerido" *ngIf="this.banderaForm && this.isEditable()"  > <mat-label>* Campos requeridos  </mat-label> </div>

        <!--Datos de la categoria y tipo de dispositivo-->
        <div class="div">
            <!--Parte 1-->
            <div class="grid-containerB">
              <div class="celda">
                <mat-label class="label">Dispositivo</mat-label>
                <mat-form-field appearance="outline" >
                   <input matInput type="text"  formControlName="activo"  required oninput="this.value = this.value.toUpperCase()"/>
                </mat-form-field>
              </div>
                <!--Tipo de dispositivo del activo seleccionado-->
                <div class="celda">
                    <mat-label class="label">Tipo<mat-label class="requerido">*</mat-label></mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Selecciona el tipo de activo"  formControlName="tipo" required (opened)="selectTipoModelo()">
                            <mat-option  *ngFor="let tipo of listaTipos" [value] = tipo.id> {{ tipo.name }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="this.banderaForm">
                  <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block"  (click)="agregarTipoModeloComponente('TIPO','')"  (ngModelChange)="selectTipoModelo" > <mat-icon>add</mat-icon> </button>
                </div>

            </div>

            <!--Parte 2-->
            <div class="grid-containerB">
                <!--Nombre de inventario-->
                <div class="celda">
                    <mat-label class="label"> Nombre de inventario <mat-label class="requerido">*</mat-label></mat-label>
                    <mat-form-field class="example-form-field" appearance="outline">
                        <input matInput type="text" placeholder="Ingresa el nombre"  formControlName="nombreInventario"  (keydown.space)="$event.preventDefault();" required oninput="this.value = this.value.toUpperCase()"  />
                        <mat-error *ngIf="this.formActualizar.get('nombreInventario')?.errors?.['required']">
                          El nombre de inventario es requerido
                        </mat-error>
                    </mat-form-field>
                </div>

                <!--Modelo del equipo-->
                <div class="celda">
                    <mat-label class="label"> Modelo <mat-label class="requerido">*</mat-label> </mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Selecciona el Modelo" formControlName="modelo" required (opened)="selectTipoModelo">
                            <mat-option *ngFor="let modelo of listaModelo" [value]="modelo.id"> {{ modelo.name }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="this.banderaForm">
                  <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block"  (click)="agregarTipoModeloComponente('MODELO','')" > <mat-icon>add</mat-icon> </button>
                </div>
            </div>
            <div class="grid-container2">

               <!--Descargar codigo de barras-->
                <div *ngIf="this.formActualizar.value.nombreInventario.length!=0" >
                 <div   id="codigoBarras" >
                  <div style="text-align:center">
                    <ngx-barcode6
                      [bc-format]="'CODE128'"
                      [bc-value]="formActualizar.value.nombreInventario"
                      [bc-display-value]="true"
                      [bc-height] = "30"
                      [bc-width]="1"
                    >
                    </ngx-barcode6>
                  </div>
                 </div>
                 <button type="button" class="btn btn-primary mt-3 mb-5 mx-auto d-block" style="background-color: #3124e9;" (click)="descargarCodigoBarras()">Descargar <mat-icon>file_download</mat-icon></button>
                </div>
                <!--Numero de serie-->
                <div class="celda">
                    <mat-label class="label"> Número de serie <mat-label class="requerido">*</mat-label> </mat-label>
                    <mat-form-field class="example-form-field" appearance="outline">
                        <input matInput type="text" placeholder="Ingresa el número de serie" formControlName="numeroSerie" required oninput="this.value = this.value.toUpperCase()"/>
                        <mat-error *ngIf="this.formActualizar.get('numeroSerie')?.errors?.['required']">
                          El número de serie es requerido
                      </mat-error>
                    </mat-form-field>
                </div>


                <!--Nombre del colaborador-->
                <div class="celda">
                    <mat-label class="label">Responsable técnico</mat-label>
                    <mat-form-field appearance="outline">
                    <mat-select placeholder="Ingresa el nombre del resp. técnico" formControlName="responsableTecnico" >
                        <mat-option *ngFor="let usuario of listaResTecnico" [value]="usuario.id"> {{usuario.realname}} {{usuario.firstname}} </mat-option>
                    </mat-select>
                    </mat-form-field>
                </div>

                <!--Sucursal donde se encuentra el equipo-->
                <div class="celda">
                    <mat-label class="label">Sucursal<mat-label class="requerido">*</mat-label></mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Sucursal" formControlName="sucursal"  required>
                            <mat-option *ngFor="let sucursal of listaSucursal" [value]="sucursal.id"> {{ sucursal.name }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Uuid -->
                <div class="celda" *ngIf="activoSeleccionado('COMPUTADORA')">
                    <mat-label class="label"> UUID (Número de identificación universal) </mat-label>
                    <mat-form-field class="example-form-field" appearance="outline">
                        <input matInput type="text"   (keydown.space)="$event.preventDefault();" placeholder="Ejm. 550e8400-e29b-41d4-a716-446655440000" formControlName="uuid" pattern="^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$" oninput="this.value = this.value.toUpperCase()"/>
                    </mat-form-field>
                </div>

                <!--Fabricante o marca del sipositivo-->
                <div class="grid-containerD">
                  <div class="celda" >
                      <mat-label class="label"> Fabricante<mat-label class="requerido">*</mat-label></mat-label>
                      <mat-form-field appearance="outline">
                          <mat-select placeholder="Selecciona al fabricante del equipo" formControlName="fabricante" (opened)="llenarListaFabricantes()" required>
                              <mat-option *ngFor="let fabricante of listaFabricante" [value]="fabricante.id"> {{ fabricante.name }} </mat-option>
                          </mat-select>
                          <mat-error *ngIf="this.formActualizar.get('fabricante')?.errors?.['required']">
                            El nombre de fabricante es requerido
                        </mat-error>
                      </mat-form-field>
                  </div>
                  <div *ngIf="this.banderaForm" >
                    <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block" (click)="agregarTipoModeloComponente('FABRICANTE', 'Manufacturer')" > <mat-icon>add</mat-icon> </button>
                  </div>
                </div>

          </div>

            <!--Parte 3-->
           <div class="grid-container" >

                <!--Estado  del equipo-->
                <div class="celda">
                    <mat-label class="label" >Estado actual<mat-label class="requerido">*</mat-label></mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Selecciona el tipo de activo" formControlName="status" required>
                            <mat-option *ngFor="let status of listaEstados" [value]=status.id>{{ status.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!--Nombre del colaborador-->
                <div class="celda">
                    <mat-label class="label">Nombre del colaborador</mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Ingresa el nombre del colaborador" formControlName="usuario" (selectionChange)="selectEmpleado()" >
                            <mat-option *ngFor="let usuario of listaEmpleados" [value]="usuario.idEmpleado">{{usuario.nombre}} {{usuario.apellidoPat}} {{usuario.apellidoMat}}  </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>


              <!--Nombre del puesto-->
              <div class="celda">
                  <mat-label class="label"> Puesto </mat-label>
                  <mat-form-field class="example-form-field" appearance="outline">
                      <input matInput type="text" placeholder="Ingresa el puesto o cargo"  formControlName="puesto" oninput="this.value = this.value.toUpperCase()"/>
                  </mat-form-field>
              </div>

              <!-- Número de unidades-->
              <div class="celda" *ngIf="activoSeleccionado('RACK')">
                <mat-label class="label"> Número de unidades </mat-label>
                <mat-form-field class="example-form-field" appearance="outline">
                    <input matInput type="number" placeholder="Ingrese el número de unidades" formControlName="numUnidades" min="0" step="1" oninput="this.value = this.value.toUpperCase()"/>
                </mat-form-field>
              </div>
            </div>

            <!--Parte 4-->
            <div class="grid-container">

                <!--Comentarios sobre el equipo-->
                <div class="celda">
                    <mat-label class="label"> Comentarios </mat-label>
                    <mat-form-field class="example-form-field" appearance="outline">
                        <input matInput type="text" formControlName="comentarios" oninput="this.value = this.value.toUpperCase()"/>
                    </mat-form-field>
                </div>

            </div>


        </div>

      <p></p>
             <!--Botones-->
      <div class="grid-container2" *ngIf="this.banderaForm" >

        <!--Boton guaradar-->
            <button type="submit" mat-raised-button color="primary"  >ACTUALIZAR       <mat-icon>save</mat-icon>  </button>


        <!--Boton cancelar-->
            <button mat-raised-button color="warn" (click)="goBack()" > CANCELAR</button>

        </div>

        <div  class="wrapper"   *ngIf="this.banderaForm==false" >
             <!--Boton cancelar-->
             <!--<button mat-raised-button  style="background-color: #00c030d0; width:350px; color: white;"  (click)="goBack()" > REGRESAR</button>-->

        </div>
    </form>

  </div>

  <!-----------------------------------------------------------------------------------VER A DETALLE DEL SISTEMA OPERATIVO---------------------------------------------------------------------------------------------->

  <div class="inicio" *ngIf="this.nomActivo=='COMPUTADORA'">
    <form #insertForm="ngForm" [formGroup]="formSistemaOperativo" (ngSubmit)="agregarComponente('SO')">
      <div class="form-group">
      </div>
        <!--TITULO -->
        <div class="grid-container2">
          <p class="titulo"> SISTEMA OPERATIVO </p>
        </div>
        <!--Datos de la categoria y tipo de dispositivo-->
        <div class="div">
            <!--Parte 1-->
            <div class="grid-containerC">
              <div class="celda">
                <mat-label class="label">Nombre del S.O.</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select placeholder="Selecciona el S.O."  formControlName="nombreSO" (opened)="llenarListasSO()" >
                      <mat-option  *ngFor="let nombreSO of listaSO" [value] = nombreSO.id> {{ nombreSO.name }} </mat-option>
                  </mat-select>
              </mat-form-field>
              </div>
              <div *ngIf="this.banderaForm">
                <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block"  (click)="agregarTipoModeloComponente('COMPONENTE','OperatingSystem')" > <mat-icon>add</mat-icon> </button>
              </div>
                <!--Tipo de dispositivo del activo seleccionado-->
                <div class="celda">
                    <mat-label class="label">Versión</mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Seleccione la versión"  formControlName="version" (opened)="llenarListasSO()" >
                            <mat-option  *ngFor="let version of listaVersionSO" [value] = version.id> {{ version.name }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="this.banderaForm">
                  <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block"  (click)="agregarTipoModeloComponente('COMPONENTE','OperatingSystemVersion')" > <mat-icon>add</mat-icon> </button>
                </div>

            </div>

            <!--Parte 2-->
            <div class="grid-containerC">
                <!--Nombre de inventario-->
                <div class="celda">
                    <mat-label class="label"> Arquitectura </mat-label>
                    <mat-form-field appearance="outline">
                      <mat-select placeholder="Seleccione la arquitectura" formControlName="arquitectura" (opened)="llenarListasSO()">
                          <mat-option *ngFor="let arquitectura of listaArquitectura" [value]="arquitectura.id"> {{ arquitectura.name }} </mat-option>
                      </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="this.banderaForm">
                    <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block"  (click)="agregarTipoModeloComponente('COMPONENTE','OperatingSystemArchitecture')" > <mat-icon>add</mat-icon> </button>
                </div>

                <!--Modelo del equipo-->
                <div class="celda">
                    <mat-label class="label"> Service pack </mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Seleccione el service pack" formControlName="servicePack" (opened)="llenarListasSO()">
                            <mat-option *ngFor="let service of listaServPack" [value]="service.id"> {{ service.name }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="this.banderaForm">
                  <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block"  (click)="agregarTipoModeloComponente('COMPONENTE','OperatingSystemServicePack')" > <mat-icon>add</mat-icon> </button>
                </div>
            </div>
            <div class="grid-container2">

                <!--Id del producto-->
                <div class="celda">
                    <mat-label class="label"> ID del producto </mat-label>
                    <mat-form-field class="example-form-field" appearance="outline">
                        <input matInput type="text" placeholder="Ingrese el ID del producto" formControlName="idProducto" (keydown.space)="$event.preventDefault();" />
                    </mat-form-field>
                </div>

                <!--Numero de serie del S.O-->
                <div class="celda">
                  <mat-label class="label"> Número de serie </mat-label>
                  <mat-form-field class="example-form-field" appearance="outline">
                      <input matInput type="text" placeholder="Ingresa el número de serie" formControlName="numeroSerieSO" (keydown.space)="$event.preventDefault();" oninput="this.value = this.value.toUpperCase()"/>
                  </mat-form-field>
              </div>

            </div>
        </div>

      <p></p>
             <!--Botone-->
        <div  class="wrapper"   *ngIf="this.banderaForm" >
          <!--Boton Guardar cambios del sistema operativo-->
          <button mat-raised-button  style="background-color: #1c04fcd0; width:350px; color: white;"   > GUARDAR   <mat-icon>save</mat-icon> </button>

     </div>
    </form>

  </div>

  <!----------------------------------------------------------------------------------------VISUALIZAR COMPONENTES ------------------------------------------------------------------------------------------------------------------>
  <div  class="inicio" *ngIf="this.nomActivo=='COMPUTADORA'" >
    <div class="infoComponent">
      <div class="titulo2">Componentes del equipo seleccionado que ya han sido previamente registrados en Glpi. </div>
      <p></p>

      <mat-label style="font-weight: bold">Nota: </mat-label>Ingrese a Glpi para agregar nuevos componentes de computadora.
    </div>
  </div>

  <div class="inicio" *ngIf="this.nomActivo=='COMPUTADORA'">
    <form #insertForm="ngForm" [formGroup]="formComponente" (ngSubmit)="actualizarEquipo()">
      <div class="form-group">
      </div>
        <!--TITULO -->
        <div class="grid-container2">
          <p class="titulo"> COMPONENTES   </p>
        </div>
        <!--Datos de la categoria y tipo de dispositivo-->
        <div class="div">
            <!--Parte 1-->
            <div class="grid-container2">
              <div class="celda">
                <mat-label class="label">Procesador</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="No se encontró este dato"  formControlName="procesador"  />
              </mat-form-field>
              </div>

                <!--Tipo de dispositivo del activo seleccionado-->
                <div class="celda">
                    <mat-label class="label">Firmware</mat-label>
                    <mat-form-field appearance="outline">
                      <input matInput type="text" placeholder="No se encontró este dato"  formControlName="firmware"  />
                    </mat-form-field>
                </div>
            </div>
        </div>

      <p></p>
             <!--Botone-->
        <div  class="wrapper"   *ngIf="this.banderaForm" >
          <!--Boton Guardar cambios de los dos componentes-->
          <!--<button mat-raised-button  style="background-color: #1c04fcd0; width:350px; color: white;"  (click)="agregarComponente('')" > GUARDAR  <mat-icon>save</mat-icon> </button>-->

     </div>
    </form>

  </div>
  <!----------------------------------------------------------------------------------------------------------TABLAS DE LOS COMPONENTES--------------------------------------------------------------------------------------->
  <div class="inicio" *ngIf="this.nomActivo=='COMPUTADORA'" style="text-align:center">
    <form #insertForm="ngForm" [formGroup]="formTablaComponente">
      <!--TABLA  DE MEMORIAS -->
      <div>
          <div class="grid-container3"  *ngIf="this.banderaForm" >
            <!--Tipos de memorias-->
            <div></div>
            <!-- <div class="celda">
              <mat-label class="label">Memoria</mat-label>
              <mat-form-field appearance="outline">
                  <mat-select placeholder="Seleccione una memoria"  formControlName="memoria" >
                      <mat-option *ngFor="let memoria of listaMemoria" [value] = memoria.id> {{ memoria.designation }} </mat-option>
                  </mat-select>
              </mat-form-field>
            </div>

            <button mat-mini-fab mat-raised-button style="background-color: #04da44cc;"  >
                <mat-icon> add_circle_outline </mat-icon>
            </button> -->
          </div>
        <!--Tabla    [dataSource] = "dataSource"-->
        <table mat-table [dataSource] = "dataSourceMemoria" class="mat-elevation-z8" class="table" style="margin: 0 auto;">

          <!-- Position Column --
          <ng-container matColumnDef="c1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
              <td mat-cell *matCellDef="let element">
                <--BOTONES
                <button mat-raised-button style="background-color: #F9DF56;" > <span class="material-icons">visibility</span> </button>
                <button mat-raised-button style="background-color: #FA9494;" > <mat-icon>cancel</mat-icon> </button>
              --
              </td>
          </ng-container>
          -->
          <!-- Name Column -->
          <ng-container matColumnDef="c1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>   MEMORIA   </th>
              <td mat-cell *matCellDef="let element"> {{element[0]}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="c2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>       FRECUENCIA   </th>
              <td mat-cell *matCellDef="let element"> {{element[1]}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="c3">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>       TAMAÑO   </th>
              <td mat-cell *matCellDef="let element"> {{element[2]}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="c4">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>       SUCURSAL   </th>
              <td mat-cell *matCellDef="let element"> {{element[3]}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
          <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

        </table>
    </div>
      <p></p>
    <!--TABLA  DE HARD DRIVES  -------------------------------------------------------------------------------------------------->
    <div>
      <div class="grid-container3" *ngIf="this.banderaForm"  >
        <!--Tipos de drives-->
        <div></div>
        <!-- <div class="celda"  >
          <mat-label class="label">Disco duro</mat-label>
          <mat-form-field appearance="outline">
              <mat-select placeholder="Seleccione el Disco duro"  formControlName="hardDrive" >
                  <mat-option *ngFor="let hardDrive of listaHardDrive" [value] = hardDrive.id> {{ hardDrive.designation }} </mat-option>
              </mat-select>
          </mat-form-field>
        </div>

        <button mat-mini-fab mat-raised-button style="background-color: #04da44cc;"  >
            <mat-icon> add_circle_outline </mat-icon>
        </button> -->
      </div>
    <!--Tabla    [dataSource] = "dataSource"-->
    <table mat-table [dataSource] = "dataSourceHardDrive" class="mat-elevation-z8" class="table" style="margin: 0 auto;">
      <ng-container matColumnDef="c1">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>   DISCO DURO   </th>
          <td mat-cell *matCellDef="let element"> {{element[0]}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="c2">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>       CAPACIDAD   </th>
          <td mat-cell *matCellDef="let element"> {{element[1]}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="c3">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>       NÚMERO DE SERIE   </th>
          <td mat-cell *matCellDef="let element"> {{element[2]}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="c4">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>       SUCURSAL   </th>
          <td mat-cell *matCellDef="let element"> {{element[3]}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
      <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

    </table>
   </div>
   <p></p>
   <!--TABLA  DE NETWORK CAD  -------------------------------------------------------------------------------------------------->
   <div>
     <div class="grid-container3" *ngIf="this.banderaForm"  >
       <!--Tipos de drives-->
       <div></div>
       <!--<div class="celda"  >
         <mat-label class="label">Tarjeta de red</mat-label>
         <mat-form-field appearance="outline">
             <mat-select placeholder="Seleccione una Tarjeta de red"  formControlName="netCard" >
                 <mat-option *ngFor="let netCard of listaNetCard" [value] = netCard.id> {{ netCard.designation }} </mat-option>
             </mat-select>
         </mat-form-field>
       </div>

       <button mat-mini-fab mat-raised-button style="background-color: #04da44cc;"  >
           <mat-icon> add_circle_outline </mat-icon>
       </button> -->
     </div>
   <!--Tabla    [dataSource] = "dataSource"-->
   <table mat-table [dataSource] = "dataSourceNetCard" class="mat-elevation-z8" class="table"  style="margin: 0 auto;">
     <ng-container matColumnDef="c1">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>   TARJETA DE RED   </th>
         <td mat-cell *matCellDef="let element"> {{element[0]}} </td>
     </ng-container>

     <!-- Name Column -->
     <ng-container matColumnDef="c2">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>       VELOCIDAD   </th>
         <td mat-cell *matCellDef="let element"> {{element[1]}} </td>
     </ng-container>

     <!-- Name Column -->
     <ng-container matColumnDef="c3">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>       DIRECCIÓN MAC   </th>
         <td mat-cell *matCellDef="let element"> {{element[2]}} </td>
     </ng-container>

     <!-- Name Column -->
     <ng-container matColumnDef="c4">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>       SUCURSAL   </th>
         <td mat-cell *matCellDef="let element"> {{element[3]}} </td>
     </ng-container>

     <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
     <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

   </table>
  </div>

  <p></p>
   <!--TABLA  DE DRIVE  -------------------------------------------------------------------------------------------------->
   <div>
     <div class="grid-container3" *ngIf="this.banderaForm"  >
       <!--Tipos de drives-->
       <div></div>
       <!-- <div class="celda"  >
         <mat-label class="label">Drive</mat-label>
         <mat-form-field appearance="outline">
             <mat-select placeholder="Seleccione un Drive"  formControlName="drive" >
                 <mat-option *ngFor="let drive of listaDrive" [value] = drive.id> {{drive.designation }} </mat-option>
             </mat-select>
         </mat-form-field>
       </div>

       <button mat-mini-fab mat-raised-button style="background-color: #04da44cc;"  >
           <mat-icon> add_circle_outline </mat-icon>
       </button> -->
     </div>
   <!--Tabla    [dataSource] = "dataSource"-->
   <table mat-table [dataSource] = "dataSourceDrive" class="mat-elevation-z8"  class="table" style="margin: 0 auto;">
     <ng-container matColumnDef="c1">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>   DRIVE   </th>
         <td mat-cell *matCellDef="let element"> {{element[0]}} </td>
     </ng-container>

     <!-- Name Column -->
     <ng-container matColumnDef="c2">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>       SUCURSAL   </th>
         <td mat-cell *matCellDef="let element"> {{element[1]}} </td>
     </ng-container>

     <tr mat-header-row *matHeaderRowDef="encabezadostabla2"></tr>
     <tr mat-row *matRowDef="let row; columns: encabezadostabla2;"></tr>

   </table>
  </div>
  <p></p>
   <!--TABLA  DE GRAPHICS CARD  -------------------------------------------------------------------------------------------------->
   <div>
     <div class="grid-container3" *ngIf="this.banderaForm"  >
       <!--Tipos de drives-->
       <div></div>
       <!--<div class="celda"  >
         <mat-label class="label">Tarjeta gráfica</mat-label>
         <mat-form-field appearance="outline">
             <mat-select placeholder="Seleccione una Tarjeta gráfica"  formControlName="graCard" >
                 <mat-option *ngFor="let graCard of listaGraCard" [value] = graCard.id> {{ graCard.designation }} </mat-option>
             </mat-select>
         </mat-form-field>
       </div>

       <button mat-mini-fab mat-raised-button style="background-color: #04da44cc;"  >
           <mat-icon> add_circle_outline </mat-icon>
       </button> -->
     </div>
   <!--Tabla    [dataSource] = "dataSource"-->
   <table mat-table [dataSource] = "dataSourceGraCard" class="mat-elevation-z8" class="table" style="margin: 0 auto;">
     <ng-container matColumnDef="c1">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>   TARJETA GRÁFICA   </th>
         <td mat-cell *matCellDef="let element"> {{element[0]}} </td>
     </ng-container>

     <!-- Name Column -->
     <ng-container matColumnDef="c2">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>       MEMORIA   </th>
         <td mat-cell *matCellDef="let element"> {{element[1]}} </td>
     </ng-container>

     <!-- Name Column -->
     <ng-container matColumnDef="c3">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>       SUCURSAL   </th>
         <td mat-cell *matCellDef="let element"> {{element[2]}} </td>
     </ng-container>


     <tr mat-header-row *matHeaderRowDef="encabezadostabla3"></tr>
     <tr mat-row *matRowDef="let row; columns: encabezadostabla3;"></tr>

   </table>
  </div>

  <p></p>
   <!--TABLA  DE SOUNDCARD  -------------------------------------------------------------------------------------------------->
   <div>
     <div class="grid-container3" *ngIf="this.banderaForm"  >
       <!--Tipos de drives-->
       <div></div>
       <!--<div class="celda"  >
         <mat-label class="label">Tarjeta de sonido</mat-label>
         <mat-form-field appearance="outline">
             <mat-select placeholder="Seleccione una Tarjeta gráfica"  formControlName="soundCard" >
                 <mat-option *ngFor="let soundCard of listaSoundCard" [value] = soundCard.id> {{ soundCard.designation }} </mat-option>
             </mat-select>
         </mat-form-field>
       </div>

       <button mat-mini-fab mat-raised-button style="background-color: #04da44cc;"  >
           <mat-icon> add_circle_outline </mat-icon>
       </button> -->
     </div>
   <!--Tabla    [dataSource] = "dataSource"-->
   <table mat-table [dataSource] = "dataSourceSoundCard" class="mat-elevation-z8" class="table" style="margin: 0 auto;">
     <ng-container matColumnDef="c1">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>   TARJETA DE SONIDO   </th>
         <td mat-cell *matCellDef="let element"> {{element[0]}} </td>
     </ng-container>

     <!-- Name Column -->
     <ng-container matColumnDef="c2">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>       SUCURSAL   </th>
         <td mat-cell *matCellDef="let element"> {{element[1]}} </td>
     </ng-container>

     <tr mat-header-row *matHeaderRowDef="encabezadostabla2"></tr>
     <tr mat-row *matRowDef="let row; columns: encabezadostabla2;"></tr>

   </table>
  </div>

  <p></p>
   <!--TABLA  DE CONTROLLERS  -------------------------------------------------------------------------------------------------->
   <div>
     <div class="grid-container3" *ngIf="this.banderaForm"  >
       <!--Tipos de drives-->
       <div></div>
       <!--<div class="celda"  >
         <mat-label class="label">Controlador</mat-label>
         <mat-form-field appearance="outline">
             <mat-select placeholder="Seleccione una Controlador"  formControlName="controller" >
                 <mat-option *ngFor="let controller of listaController" [value] = controller.id> {{ controller.designation }} </mat-option>
             </mat-select>
         </mat-form-field>
       </div>

       <button mat-mini-fab mat-raised-button style="background-color: #04da44cc;"  >
           <mat-icon> add_circle_outline </mat-icon>
       </button> -->
     </div>
   <!--Tabla    [dataSource] = "dataSource"-->
   <table mat-table [dataSource] = "dataSourceController" class="mat-elevation-z8" class="table" style="margin: 0 auto;">
     <ng-container matColumnDef="c1">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>   CONTROLADOR   </th>
         <td mat-cell *matCellDef="let element"> {{element[0]}} </td>
     </ng-container>

     <!-- Name Column -->
     <ng-container matColumnDef="c2">
         <th mat-header-cell *matHeaderCellDef mat-sort-header>       SUCURSAL   </th>
         <td mat-cell *matCellDef="let element"> {{element[1]}} </td>
     </ng-container>


     <tr mat-header-row *matHeaderRowDef="encabezadostabla2"></tr>
     <tr mat-row *matRowDef="let row; columns: encabezadostabla2;"></tr>

   </table>
  </div>
   </form>
  </div>






